import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { useProvider } from '~/Hooks';
import { selectErrors, selectLoading, requestClearError } from '~/store/app';
import {
  requestCreateLocation,
  requestProviderLocationsList,
  requestUpdateLocation,
  selectLocationList,
} from '~/store/provider';
import { dispatchFailure } from '~/Helpers/Request.helper';

export const useLocations = () => {
  const dispatch = useDispatch();
  const { currentProvider } = useProvider();

  const locationList = useSelector(selectLocationList);
  const isLoadingList = useSelector(selectLoading(REQUEST_ACTIONS.LOCATION_LIST));
  const isLoadingUpdate = useSelector(selectLoading(REQUEST_ACTIONS.LOCATION_UPDATE));
  const isLoadingCreate = useSelector(selectLoading(REQUEST_ACTIONS.LOCATION_CREATE));
  const errorList = useSelector(selectErrors(REQUEST_ACTIONS.LOCATION_LIST));
  const errorUpdate = useSelector(selectErrors(REQUEST_ACTIONS.LOCATION_UPDATE));
  const errorCreate = useSelector(selectErrors(REQUEST_ACTIONS.LOCATION_CREATE));

  const loadLocations = bindActionCreators(requestProviderLocationsList, dispatch);
  const updateLocation = bindActionCreators(requestUpdateLocation, dispatch);
  const createLocation = bindActionCreators(requestCreateLocation, dispatch);
  const cleanErrorMessages = bindActionCreators(requestClearError, dispatch);
  const updateLocationError = (erorr: Error) =>
    dispatchFailure(dispatch, REQUEST_ACTIONS.LOCATION_UPDATE, erorr, null, null);

  useEffect(() => {
    cleanErrorMessages(REQUEST_ACTIONS.LOCATION_UPDATE);
    cleanErrorMessages(REQUEST_ACTIONS.LOCATION_CREATE);
  }, []);

  useEffect(() => {
    if (!isLoadingList && !errorList && currentProvider && !locationList.length) {
      loadLocations(currentProvider.uuid);
    }
  }, [currentProvider?.uuid]);

  return {
    locationList,
    isLoadingList,
    isLoadingUpdate,
    isLoadingCreate,
    errorList,
    errorUpdate,
    errorCreate,
    updateLocation,
    createLocation,
    updateLocationError,
  };
};
